import React, { useState } from 'react';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	name: string;
	label?: string;
	required?: boolean;
	infoMessage?: string;
	onlyAdults?: boolean;
}

export function FechaInput(props: Props) {
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const isAdult = (value: string) => {
		if (!value) return true;
		const birthDate = new Date(value);
		const today = new Date();
		const age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;

		if (props.onlyAdults && actualAge < 18) return false;
		return true;
	};

	const isAlive = (value: string) => {
		if (!value) return true;
		const birthDate = new Date(value);
		const today = new Date();
		const age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;

		if (actualAge > 100) return false;
		return true;
	};

	const validate = (value: string) => {
		if (!value) {
			setErrorMessage(undefined);
			return true;
		}
		if (!isAlive(value)) {
			setErrorMessage('Fecha incorrecta');
			return false;
		}
		if (props.onlyAdults && !isAdult(value)) {
			setErrorMessage('Debes ser mayor de edad');
			return false;
		}
		setErrorMessage(undefined);
		return true;
	};

	return (
		<TextInputExtended
			{...props}
			// @ts-ignore (type date es correcto)
			type="date"
			label={props.label || 'Fecha'}
			errorMessage={errorMessage}
			validate={validate}
		/>
	);
}
